import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit {
  @ViewChild('vform') validationForm: FormGroup;

  businessForm:FormGroup;
  fileData:File
  businessFormSubmitted:boolean=false;
  categoryList: any;
  catId: "631ad8d1ce5c666542591bdd";
  selected_type=null
  refrences:any
  constructor(private formBuilder: FormBuilder,
    public toastr: ToastrService,
              public apiService:ApiService,
              private route:Router) { 
    this.getTagByCategory()

              }

  ngOnInit() {
    this.businessForm=this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      about: ['', Validators.required],
      admin_notes: ['', Validators.required],
      facebook_url: ['', Validators.required],
      linked_url: ['', Validators.required],
      website: ['', Validators.required],
      phone: ['', [Validators.required,Validators.minLength(10),Validators.maxLength(10)]],
      address: ['', Validators.required],
      notes: ['', Validators.required],
    })
  }
  get rf() {
    return this.businessForm.controls;
  }
  setFocus(event) {
    this.refrences = event.html
  }
  submit() {   
    let body = {
      name: this.businessForm.value.name,
      about: this.businessForm.value.about,
      address: this.businessForm.value.address,
      email: this.businessForm.value.email,
      phone: this.businessForm.value.phone,
      type: this.selected_type,
      website: this.businessForm.value.website,
      facebook_url: this.businessForm.value.facebook_url,
      linked_url: this.businessForm.value.linked_url,
      notes: this.businessForm.value.notes,
      admin_notes: this.businessForm.value.admin_notes,
      refrences: this.refrences
    }
  this.apiService.createBusiness(body).subscribe((res:any)=>{
    if(res.statusCode === 200){
      console.log('Business create res',res)
       this.toastr.success('Created Successfully',res.message)
    }
    else{this.toastr.error(res.error)}
    this.route.navigate(['/business/list'])    
  })
    this.businessFormSubmitted = true;
  if (this.businessForm.invalid) {
    return;
  }
  }
  getTagByCategory(){
    this.apiService.getTagByTagCatgoryId("631ad8d1ce5c666542591bdd").subscribe((res:any)=>{
      console.log('courseIntrest ',res)
      this.categoryList=res.data
    })
  }
  getTypeId(event) {
    console.log(this.selected_type)
  }
 
  onSelectFile(event:any){
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.fileData = event.target.files[0];
      reader.readAsDataURL(event.target.files[0]);
      console.log('event',this.fileData)
    }
  }
 back(){
  this.route.navigate(['/business/list'])    
 } 
  
}

